import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const QuickMenuBarType2 = styled.div`
  ${mixin.flex({
    direction: 'column',
    align: 'flex-start',
    justify: 'flex-start',
  })}
  gap: 6px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .quickmenu-row {
    ${mixin.flex({ justify: 'flex-start' })}
    gap: 6px;
    width: max-content;
    margin: 0 auto;
    padding: 0 16px;
  }

  .btn {
    flex-shrink: 0;
  }

  @media ${({ theme }) => theme.media.smMax} {
    gap: ${mixin.pxToVw('6')};

    .quickmenu-row {
      gap: ${mixin.pxToVw('6')};
      padding: ${mixin.pxToVw('0 16')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    ${mixin.flex({ align: 'center', justify: 'center', wrap: 'wrap' })}
    gap: 8px;
    width: var(--pc-width);
    margin: 0 auto;
    overflow-x: visible;
  }
`;
